import { createAsyncThunk, EntityId } from '@reduxjs/toolkit';

export const deleteOneaffacturageType = createAsyncThunk(
    '[affacturage-TYPE] deleteOneaffacturageType',
    async (id: EntityId, thunk: any) => {
        try {
            return thunk.extra.affacturageTypeQuery._delete(id);
        } catch (error: any) {
            return thunk.rejectWithValue({ message: error.message ?? null });
        }
    }
);
